// ----------------------------------------------------------------------
// Master Data and Helper for Book Category Classification
// Based on: __docs__/20260923_หมวดหมู่TKLib.xlsx (ca_category_202609231632)
// ----------------------------------------------------------------------

export const BOOK_CATEGORIES = [
  {
    key: 'c0',
    no: 'c0',
    en: 'General Interest',
    th: 'ความรู้ทั่วไป',
    category: 'ความรู้ทั่วไป',
    catnolist: '000-003,007-099',
    numRanges: [
      { min: 0, max: 3.999999 },
      { min: 7, max: 99.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c1',
    en: 'Computer and IT',
    th: 'คอมพิวเตอร์และไอที',
    catnolist: '004-006',
    numRanges: [
      { min: 4, max: 6.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c2',
    en: 'Philosophy and Ethics',
    th: 'ปรัชญาและจริยธรรม',
    catnolist: '100-149,170-199',
    numRanges: [
      { min: 100, max: 149.999999 },
      { min: 170, max: 199.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c3',
    en: 'Self-Help',
    th: 'จิตวิทยาพัฒนาตนเอง',
    catnolist: '150-155.39,155.6-169, 808.5-808.59',
    numRanges: [
      { min: 150, max: 155.39 },
      { min: 155.6, max: 169.999999 },
      { min: 808.5, max: 808.59 }
    ],
    prefixes: []
  },
  {
    key: 'c4',
    en: 'Child Development',
    th: 'พัฒนาการเด็กและครอบครัว',
    catnolist: '155.4-155.59,649',
    numRanges: [
      { min: 155.4, max: 155.59 },
      { min: 649, max: 649.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c5',
    en: 'Religion',
    th: 'ศาสนา',
    catnolist: '200-299',
    numRanges: [
      { min: 200, max: 299.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c6',
    en: 'Society and Politics',
    th: 'สังคมและการเมือง',
    catnolist: '300-329,350-369',
    numRanges: [
      { min: 300, max: 329.999999 },
      { min: 350, max: 369.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c7',
    en: 'Money and Investment',
    th: 'การเงินและการลงทุน',
    catnolist: '330-339',
    numRanges: [
      { min: 330, max: 339.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c8',
    en: 'Law',
    th: 'กฎหมาย',
    catnolist: '340-349',
    numRanges: [
      { min: 340, max: 349.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c9',
    en: 'Education',
    th: 'การศึกษา',
    catnolist: '370-379',
    numRanges: [
      { min: 370, max: 379.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c10',
    en: 'Business and Marketing',
    th: 'ธุรกิจและการตลาด',
    catnolist: '380-389,650-659',
    numRanges: [
      { min: 380, max: 389.999999 },
      { min: 650, max: 659.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c11',
    en: 'Culture and Traditions',
    th: 'วัฒนธรรมและประเพณี',
    catnolist: '390-399',
    numRanges: [
      { min: 390, max: 399.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c12',
    en: 'Languages',
    th: 'ภาษา',
    catnolist: '400-499',
    numRanges: [
      { min: 400, max: 499.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c13',
    en: 'Sciences',
    th: 'วิทยาศาสตร์',
    catnolist: '500-599',
    numRanges: [
      { min: 500, max: 599.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c14',
    en: 'Well-being and Beauty',
    th: 'สุขภาพและความงาม',
    catnolist: '610-619,646.7-646.9',
    numRanges: [
      { min: 610, max: 619.999999 },
      { min: 646.7, max: 646.9 }
    ],
    prefixes: []
  },
  {
    key: 'c15',
    en: 'Food and Beverages',
    th: 'อาหารและเครื่องดื่ม',
    catnolist: '641-642',
    numRanges: [
      { min: 641, max: 642.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c16',
    en: 'Tech',
    th: 'เทคโนโลยี',
    catnolist: '600-609,620-629,660-699',
    numRanges: [
      { min: 600, max: 609.999999 },
      { min: 620, max: 629.999999 },
      { min: 660, max: 699.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c17',
    en: 'Agriculture and Pets',
    th: 'เกษตรกรรมและสัตว์เลี้ยง',
    catnolist: '630-639',
    numRanges: [
      { min: 630, max: 639.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c18',
    en: 'Home & Garden',
    th: 'ตกแต่งบ้าน จัดสวน',
    catnolist: '640-640.9,643-645,648,712,720-729,747,749',
    numRanges: [
      { min: 640, max: 640.9 },
      { min: 643, max: 645.999999 },
      { min: 648, max: 648.999999 },
      { min: 712, max: 712.999999 },
      { min: 720, max: 729.999999 },
      { min: 747, max: 747.999999 },
      { min: 749, max: 749.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c19',
    en: 'Hobbies and Crafts',
    th: 'งานอดิเรก งานฝีมือ',
    catnolist: '646-646.6,745.5-746,770-799',
    numRanges: [
      { min: 646, max: 646.6 },
      { min: 745.5, max: 746.999999 },
      { min: 770, max: 799.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c20',
    en: 'Traveling',
    th: 'ท่องเที่ยว',
    catnolist: '647,910-919',
    numRanges: [
      { min: 647, max: 647.999999 },
      { min: 910, max: 919.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c21',
    en: 'Arts',
    th: 'ศิลปะ',
    catnolist: '700-711,713-719,730-745.49,748,750-769',
    numRanges: [
      { min: 700, max: 711.999999 },
      { min: 713, max: 719.999999 },
      { min: 730, max: 745.49 },
      { min: 748, max: 748.999999 },
      { min: 750, max: 769.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c22',
    en: 'Literature',
    th: 'วรรณกรรมและวรรณคดี',
    catnolist: '800-808.49,808.6-899',
    numRanges: [
      { min: 800, max: 808.49 },
      { min: 808.6, max: 899.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c23',
    en: 'History',
    th: 'ประวัติศาสตร์',
    catnolist: '900-909,930-999',
    numRanges: [
      { min: 900, max: 909.999999 },
      { min: 930, max: 999.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c24',
    en: 'Biography',
    th: 'ชีวประวัติ',
    catnolist: '920-929',
    numRanges: [
      { min: 920, max: 929.999999 }
    ],
    prefixes: []
  },
  {
    key: 'c25',
    en: 'Magazine',
    th: 'นิตยสาร',
    catnolist: 'Magazine, นิตยสาร',
    numRanges: [],
    prefixes: ['magazine', 'นิตยสาร']
  },
  {
    key: 'c26',
    en: 'Thai Fiction',
    th: 'นวนิยายไทย',
    catnolist: 'นว',
    numRanges: [],
    prefixes: ['นว']
  },
  {
    key: 'c27',
    en: 'Translate Fiction',
    th: 'เรื่องแปล',
    catnolist: 'รป',
    numRanges: [],
    prefixes: ['รป']
  },
  {
    key: 'c28',
    en: 'Short Stories',
    th: 'เรื่องสั้น',
    catnolist: 'รส',
    numRanges: [],
    prefixes: ['รส']
  },
  {
    key: 'c29',
    en: 'Comic / Manga',
    th: 'การ์ตูน/มังงะ',
    catnolist: 'ก, C',
    numRanges: [],
    prefixes: ['ก', 'c']
  },
  {
    key: 'c30',
    en: 'Fiction',
    th: 'นวนิยายภาษาต่างประเทศ',
    catnolist: 'FIC',
    numRanges: [],
    prefixes: ['fic']
  },
  {
    key: 'c31',
    en: "Children's Books",
    th: 'หนังสือเด็ก',
    catnolist: 'J, ยว',
    numRanges: [],
    prefixes: ['j', 'ยว']
  }
];

BOOK_CATEGORIES.forEach((c) => {
  c.no = c.key;
  c.category = c.th;
});

const UNMATCHED_CATEGORY = {
  key: 'c32',
  no: 'c32',
  en: 'Others',
  th: 'อื่นๆ',
  category: 'อื่นๆ',
  catnolist: '-',
  numRanges: [],
  prefixes: []
};

/**
 * Classifies a book call number or book number string into one of the 32 categories.
 *
 * @param {string} rawInput - callNo, groupCallNo, or bookNumber
 * @param {string} [lang='th'] - 'th' or 'en'
 * @returns {object} { key, th, en, label }
 */
export function classifyCallNumber(rawInput, lang = 'th') {
  if (!rawInput || typeof rawInput !== 'string') {
    return {
      ...UNMATCHED_CATEGORY,
      label: lang === 'en' ? UNMATCHED_CATEGORY.en : UNMATCHED_CATEGORY.th
    };
  }

  const trimmed = rawInput.trim();
  if (!trimmed || trimmed === '-') {
    return {
      ...UNMATCHED_CATEGORY,
      label: lang === 'en' ? UNMATCHED_CATEGORY.en : UNMATCHED_CATEGORY.th
    };
  }

  const lower = trimmed.toLowerCase();

  // 1. Check text prefixes (e.g. นว, รป, รส, ก, C, FIC, J, ยว, Magazine, นิตยสาร)
  // Sort prefixes by length descending so longer matches take precedence
  for (let i = 0; i < BOOK_CATEGORIES.length; i += 1) {
    const cat = BOOK_CATEGORIES[i];
    if (cat.prefixes && cat.prefixes.length > 0) {
      for (let j = 0; j < cat.prefixes.length; j += 1) {
        const prefix = cat.prefixes[j];
        if (
          lower === prefix ||
          lower.startsWith(`${prefix} `) ||
          lower.startsWith(`${prefix}.`) ||
          lower.startsWith(`${prefix}/`) ||
          lower.startsWith(prefix)
        ) {
          return {
            ...cat,
            label: lang === 'en' ? cat.en : cat.th
          };
        }
      }
    }
  }

  // 2. Check numeric Dewey ranges (e.g. 005.133, 158.1, 909, 332.178)
  const numMatch = trimmed.match(/^(\d+(\.\d+)?)/);
  if (numMatch) {
    const val = parseFloat(numMatch[1]);
    for (let i = 0; i < BOOK_CATEGORIES.length; i += 1) {
      const cat = BOOK_CATEGORIES[i];
      if (cat.numRanges && cat.numRanges.length > 0) {
        for (let j = 0; j < cat.numRanges.length; j += 1) {
          const range = cat.numRanges[j];
          if (val >= range.min && val <= range.max) {
            return {
              ...cat,
              label: lang === 'en' ? cat.en : cat.th
            };
          }
        }
      }
    }
  }

  return {
    ...UNMATCHED_CATEGORY,
    label: lang === 'en' ? UNMATCHED_CATEGORY.en : UNMATCHED_CATEGORY.th
  };
}
